import {RouteService} from './routeService';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DropboxService {

    constructor(private rs:RouteService) {}

    getloginurl(callback) {
        this.rs.dropboxGetAuthorizationURL().then(function (res) {
            let url = res && res.url;
            if(!url) {
                callback('clio url is empty');
            }
            else {
                callback(null, url);
            }
        }, err => {
            callback(err);
        });
    }

    getalldocs(callback) {
        this.rs.dropboxGetAllDocs().then(function (res) {
            if(!res) {
                callback('no clio documents');
            }
            else {
                callback(null, res);
            }
        }, err => {
            callback(err);
        });
    }

    attachdoc(doc_ids, callback) {
        this.rs.dropboxUploadDoc(doc_ids).then(function (res) {
            if(!res) {
                callback('no clio documents');
            }
            else {
                callback(null, res);
            }
        }, err => {
            callback(err);
        });
    };
}
